import React, { Component } from 'react';
import { Alert, Button, Card, CardBody, CardImg, CardTitle, Form, FormGroup, Input, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import qs from 'query-string';
import { actions as authActions } from '~/redux/auth';
import { getMessage } from '~/utils/errorCodes';
import Spinner from '~/components/spinner/spinner';
import img from './background.jpg';
import styles from './styles.css';

export class LoginPage extends Component {
  constructor(props) {
    super(props);

    const parsed = qs.parse(this.props.location.search);

    this.state = {
      email: parsed.email || '',
      password: '',
      loggingIn: false,
      error: null
    };
  }

  onInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  loginWithEmailPassword = event => {
    event.preventDefault();
    const { email, password, loggingIn } = this.state;

    if (!email.length || !password.length || loggingIn) {
      this.setState({
        error: 'Please enter both your email address and password'
      });
      return;
    }

    this.setState({
      error: null,
      loggingIn: true
    });

    this.props.loginWithEmailPassword(email, password).catch(err => {
      console.log('Error logging in', err);
      this.setState({
        loggingIn: false,
        error: getMessage(err.code)
      });
    });
  };

  renderAlert = () => {
    const parsed = qs.parse(this.props.location.search);
    if (parsed.msg) {
      return <Alert color="success">{parsed.msg}</Alert>;
    }

    return null;
  };

  render() {
    const { email, password, error, loggingIn } = this.state;
    const buttonInner = loggingIn ? <Spinner className={`stroke-white ${styles.spinner}`} /> : 'Login';

    return (
      <div className="auth-container">
        <div className="absolute-center z-1">
          <Card className="auth-card">
            <CardImg top width="100%" src={img} alt="Login" />
            <CardBody>
              {this.renderAlert()}
              {error ? <Alert color="danger">{error}</Alert> : this.renderAlert()}
              <CardTitle className="tc">Login</CardTitle>
              <Form onSubmit={this.loginWithEmailPassword}>
                <FormGroup>
                  <Label>Email address</Label>
                  <Input
                    data-qa="login-email"
                    autoFocus
                    type="email"
                    name="email"
                    value={email}
                    onChange={this.onInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Password</Label>
                  <Input
                    data-qa="login-password"
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.onInputChange}
                  />
                </FormGroup>
                <div className="flex justify-between align-items-center">
                  <Button data-qa="login-submit" color="primary">
                    {buttonInner}
                  </Button>
                  <Link to="/forgotpassword">Forgot your password?</Link>
                </div>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loginWithEmailPassword: authActions.loginWithEmailPassword
    },
    dispatch
  );
}

export default connect(
  state => state.auth,
  mapDispatchToProps
)(withRouter(LoginPage));



// WEBPACK FOOTER //
// ./src/pages/login/login.jsx